import { Button } from "@knowtex-ai/components";
import { NavArrowDown, NavArrowUp } from "iconoir-react";
import type { ReactElement } from "react";
import { getNoteToggleLabel } from "./recordLeftPaneRules";

export interface RecordNoteToggleProps {
  className?: string;
  isOpen: boolean;
  isPrecharting: boolean;
  wordCount: number;
  onToggle: () => void;
}

export default function RecordNoteToggle({
  className,
  isOpen,
  isPrecharting,
  wordCount,
  onToggle,
}: RecordNoteToggleProps): ReactElement {
  const label = getNoteToggleLabel({ isOpen, isPrecharting });
  const wordCountSuffix = wordCount > 0 && !isOpen ? ` (${wordCount} words)` : "";

  return (
    <Button
      type="button"
      variant="secondary-alt"
      icon={isOpen ? NavArrowDown : NavArrowUp}
      className={className}
      onClick={onToggle}
      aria-expanded={isOpen}
    >
      {`${label}${wordCountSuffix}`}
    </Button>
  );
}
